import makeStyles from '@mui/styles/makeStyles';

const transferStyles = makeStyles((theme) => ({
    greyTitle: {
        fontFamily: 'Roboto',
        fontStyle: 'normal',
        fontWeight: 500,
        fontSize: '14px',
        lineHeight: '22px',
        color: theme.palette.text.secondary,
    },
    blackTitle: {
        fontFamily: 'Roboto',
        fontStyle: 'normal',
        fontWeight: 500,
        fontSize: '16px',
        lineHeight: '22px',
        display: 'flex',
        alignItems: 'center',
        color: theme.palette.text.primary,
    },
    blueContent: {
        fontFamily: 'Roboto',
        fontStyle: 'normal',
        fontWeight: 500,
        fontSize: '16px',
        lineHeight: '22px',
        display: 'flex',
        alignItems: 'center',
        color: theme.palette.primary.main,
    },

    subtitle: {
        fontFamily: 'Roboto',
        fontStyle: 'normal',
        fontWeight: 'normal',
        fontSize: '12px',
        lineHeight: '22px',
        display: 'flex',
        alignItems: 'center',
        color: theme.palette.text.primary,
    },
    hr: {
        border: '1px solid #CBCFD4',
    },
    amount: {
        fontFamily: 'Saira',
        fontStyle: 'normal',
        fontWeight: 500,
        fontSize: '26px',
        lineHeight: '36px',
        color: theme.palette.primary.main,
        textAlign: 'end',
    },
    historyDetailsTable: {
        padding: '0.8rem',
    },
    reasonField: {
        marginTop: '1rem',
    },
    buttonAlignment: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        marginTop: '1rem',
    },
    red: {
        color: theme.palette.error.main,
    },
    green: {
        color: theme.palette.success.main,
    },
    grey: {
        color: theme.palette.text.secondary,
    },
}));

export default transferStyles;
